import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import AccountCircle from '@mui/icons-material/AccountCircle';

import useStyles from './styles';

const AvatarImage = ({
  onClick,
  src,
  size,
  borderColor,
  fallbackSrc,
}) => {
  const { classes } = useStyles({ size, borderColor, onClick });
  const [srcLoadErr, setSrcLoadErr] = useState();
  const [currentSrc, setCurrentSrc] = useState(src);

  useEffect(() => {
    setCurrentSrc(src);
    setSrcLoadErr(false);
  }, [src]);

  console.log(fallbackSrc);

  return (
    <Box className={classes.root}>
      <Box className={classes.container}>
        <Tooltip title={onClick ? 'Click to upload avatar' : null} placement="top">
          <Box className={classes.avatar}>
            {(srcLoadErr || (!currentSrc && !fallbackSrc))
              ? <AccountCircle className={classes.noavatar} />
              : (
                <img
                  className={classes.image}
                  src={currentSrc}
                  alt=""
                  onError={(e) => {
                    e.target.error = null;
                    if (currentSrc === src && fallbackSrc) {
                      setCurrentSrc(fallbackSrc);
                    } else {
                      setSrcLoadErr(true);
                    }
                  }}
                />
              )}
            <Box className={classes.overlay} onClick={(e) => onClick && onClick(e)} />
          </Box>
        </Tooltip>
      </Box>
    </Box>
  );
};

AvatarImage.defaultProps = {
  onClick: null,
  src: null,
  size: 'large',
  borderColor: 'white',
  fallbackSrc: null,
};

AvatarImage.propTypes = {
  onClick: PropTypes.func,
  src: PropTypes.string,
  size: PropTypes.oneOf(['s', 'm', 'l', 'xl', 'large']),
  borderColor: PropTypes.string,
  fallbackSrc: PropTypes.string,
};

export default AvatarImage;
